$(document).ready(function(){
  $('.cst--new-product .productForm-submit').click(function(){
    setTimeout(function() {
      $('.bold-custom-cart-drawer').addClass('active');
    }, 1000); // 1000 milliseconds = 1 second
  });
});

// show announcement bar js fade in fade out

document.addEventListener("DOMContentLoaded", function() {

  const items = document.querySelectorAll('.announcement-item');
  let index = 0;

  function showNextItem() {
    items.forEach(item => item.classList.remove('active'));
    items[index].classList.add('active');
    index = (index + 1) % items.length;
  }

  showNextItem(); // Show first one immediately
  setInterval(showNextItem, 3000); // Every 3 seconds fade
});

// toggle single product page

document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".description-toggle-btn").forEach(btn => {

    const content = btn.nextElementSibling;
    const arrowImg = btn.querySelector(".arrow-img");

    // default open (optional – description ke liye)
    arrowImg.classList.add("rotate");
    content.classList.remove("closed");

    btn.addEventListener("click", () => {
      arrowImg.classList.toggle("rotate");
      content.classList.toggle("closed");
    });

  });

});



// mega menu css hover

document.addEventListener("DOMContentLoaded", function () {

  // Function to activate default submenu items
  function activateDefault(submenu) {
    const firstLeft = submenu.querySelector(".submenu-left-item");
    const firstBox = submenu.querySelector(".submenu-products");

    if (firstLeft) firstLeft.classList.add("active-left");
    if (firstBox) firstBox.classList.add("active");
  }

  // DEFAULT ACTIVE WHEN PAGE LOADS
  document.querySelectorAll(".submenu-two-column").forEach(submenu => {
    activateDefault(submenu);
  });

  // DEFAULT ACTIVE WHEN MENU OPENS (HOVER)
  document.addEventListener("mouseenter", function (e) {
    // Make sure e.target is an Element
    if (!(e.target instanceof Element)) return;

    let submenu = e.target.closest(".menu-item")?.querySelector(".submenu-two-column");
    if (!submenu) return;

    // If already has active, skip
    if (submenu.querySelector(".submenu-products.active")) return;

    activateDefault(submenu);
  }, true);

  // HOVER FUNCTIONALITY FOR LEFT ITEMS
  document.addEventListener("mouseover", function (e) {
    if (!(e.target instanceof Element)) return;

    let item = e.target.closest(".submenu-left-item");
    if (!item) return;

    let submenu = item.closest(".submenu-two-column");
    if (!submenu) return;

    let handle = item.getAttribute("data-collection");
    let box = submenu.querySelector("#products-" + handle);

    submenu.querySelectorAll(".submenu-left-item")
      .forEach(i => i.classList.remove("active-left"));

    submenu.querySelectorAll(".submenu-products")
      .forEach(b => b.classList.remove("active"));

    item.classList.add("active-left");
    if (box) box.classList.add("active");
  });

});



// ---------- FUNCTION FOR DEFAULT ACTIVE ----------
function activateDefault(submenu) {
  let items = submenu.querySelectorAll(".submenu-left-item");
  let boxes = submenu.querySelectorAll(".submenu-products");

  if (!items.length || !boxes.length) return;

  // Reset first
  items.forEach(i => i.classList.remove("active-left"));
  boxes.forEach(b => b.classList.remove("active"));

  // Activate first available collection
  items[0].classList.add("active-left");
  boxes[0].classList.add("active");
}




document.addEventListener("DOMContentLoaded", function () {
  const menuLinks = document.querySelectorAll(".main-menu-link");
  const allSubmenus = document.querySelectorAll(".submenu-block");

  // ---- DEFAULT ACTIVE ON LOAD ----
  if (allSubmenus.length > 0) {
    allSubmenus.forEach(sub => sub.classList.remove("active"));
    allSubmenus[0].classList.add("active");
  }

  // ---- CLICK ACTION ----
  menuLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      const handle = this.dataset.parent;
      const target = document.querySelector(`.submenu-block[data-parent="${handle}"]`);

      if (target) {
        e.preventDefault();

        // remove all active
        allSubmenus.forEach(sub => sub.classList.remove("active"));

        // add active to clicked submenu
        target.classList.add("active");
      }

      
      else {
        // Do NOT preventDefault
        window.location.href = this.getAttribute("href");
      }
    });
  });
});




// grid block add to cart

  // document.addEventListener("DOMContentLoaded", function () {
  //   const forms = document.querySelectorAll(".add-to-cart-form");

  //   if (!forms.length) return; // safety

  //   forms.forEach(form => {
  //     form.addEventListener("submit", function (e) {
  //       e.preventDefault();

  //       let btn = form.querySelector(".add-to-cart-btns");
  //       let formData = new FormData(form);

  //       if (btn) btn.innerText = "Adding...";

  //       fetch("/cart/add.js", {
  //         method: "POST",
  //         body: formData
  //       })
  //       .then(res => {
  //         if (!res.ok) throw new Error("Failed");
  //         return res.json();
  //       })
  //       .then(() => {
  //         if (btn) btn.innerText = "Added ✓";
  //         window.location.href = "/cart"; // redirect to cart page
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         if (btn) btn.innerText = "Sorry, looks like we don't have enough of this product. Please try adding fewer items to your cart.";
  //       });
  //     });
  //   });
  // });


document.addEventListener("DOMContentLoaded", function () {

  // ✅ Only Spanish URL
  if (!window.location.pathname.startsWith("/es")) return;

   const CART_TEXT = "AGREGAR AL CARRO";
  const WISHLIST_TEXT = "AGREGAR A LA LISTA DE DESEO";

  function updateAddToCart() {
    document.querySelectorAll("button[name='checkout'], .js-productForm-submit")
      .forEach(btn => {
        if (btn.textContent.trim().toLowerCase().includes("add")) {
          btn.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
              node.nodeValue = " " + CART_TEXT + " ";
            }
          });
        }
      });
  }

  function updateWishlist() {
    document.querySelectorAll("button[aria-label='Add to wishlist']")
      .forEach(btn => {
        btn.setAttribute("aria-label", WISHLIST_TEXT);

        btn.querySelectorAll("span").forEach(span => {
          span.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE &&
                node.nodeValue.toLowerCase().includes("add")) {
              node.nodeValue = " " + WISHLIST_TEXT;
            }
          });
        });
      });
  }

  function updateAll() {
      updateAddToCart();
    updateWishlist();
  }

  // ✅ Initial
  updateAll();

  // ✅ Shopify / App re-render support (SAFE)
  let timeout;
  const observer = new MutationObserver(() => {
    clearTimeout(timeout);
    timeout = setTimeout(updateAll, 100);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

function updateFreeShippingFromDOM() {
  const wrapper = document.querySelector(".free-shipping-wrapper");
  const subtotalEl = document.querySelector(".cart-total-price");

  if (!wrapper || !subtotalEl) return;

  const limit = parseFloat(wrapper.dataset.limit);

  
  const subtotalText = subtotalEl.innerText.replace(/[^0-9.]/g, "");
  const total = parseFloat(subtotalText);

  const text = wrapper.querySelector(".free-shipping-text");
  const bar  = wrapper.querySelector(".free-shipping-progress");

  if (total >= limit) {
    text.innerText = "🎉 You’ve unlocked FREE shipping!";
    bar.style.width = "100%";
  } else {
    const remaining = (limit - total).toFixed(2);
    const progress = Math.min((total / limit) * 100, 100);

    text.innerText = `You’re $${remaining} away from free shipping`;
    bar.style.width = progress + "%";
  }
// Free Gift Logic
const giftWrapper = document.querySelector('.free-gift-wrapper');
if (giftWrapper) {
  const giftLimit = parseFloat(giftWrapper.dataset.limit);
  const giftText = giftWrapper.querySelector('.free-gift-text');
  if (giftText) {
    if (total >= giftLimit) {
      giftText.innerText = "🎁 You've unlocked a FREE Gift!";
    } else {
      const giftRemaining = (giftLimit - total).toFixed(2);
      giftText.innerText = `Add Just $${giftRemaining} more to get a free gift`;
    }
  }
}



}

/* 🔥 Observe subtotal changes */
document.addEventListener("DOMContentLoaded", () => {
  const subtotalEl = document.querySelector(".cart-total-price");
  if (!subtotalEl) return;

  // First load
  updateFreeShippingFromDOM();

  const observer = new MutationObserver(() => {
    updateFreeShippingFromDOM();
  });

  observer.observe(subtotalEl, {
    childList: true,
    characterData: true,
    subtree: true
  });
});


window.updateFreeShipping = function () {
  if (!window.freeShippingEnabled) return;

  var wrapper = document.querySelector('.free-shipping-wrapper');
  var totalEl = document.querySelector('.cart-total-price');
  if (!wrapper || !totalEl) return;

  var limit = parseFloat(wrapper.dataset.limit);
  var total = parseFloat(
    (totalEl.innerText || totalEl.textContent).replace(/[^0-9.]/g, '')
  ) || 0;

  var text = wrapper.querySelector('.free-shipping-text');
  var bar  = wrapper.querySelector('.free-shipping-progress');
  if (!text || !bar) return;

  wrapper.style.display = 'block'; // show ONLY after enabled

  if (total >= limit) {
    text.innerText = "🎉 You've unlocked FREE shipping!";
    bar.style.width = "100%";
  } else {
    var remaining = (limit - total).toFixed(2);
    bar.style.width = Math.min((total / limit) * 100, 100) + "%";
    text.innerText = "You're $" + remaining + " away from free shipping";
  }

// Free Gift Logic
var giftWrapper = document.querySelector('.free-gift-wrapper');
if (giftWrapper) {
  var giftLimit = parseFloat(giftWrapper.dataset.limit);
  var giftText = giftWrapper.querySelector('.free-gift-text');
  if (giftText) {
    if (total >= giftLimit) {
      giftText.innerText = "🎁 You've unlocked a FREE Gift!";
    } else {
      var giftRemaining = (giftLimit - total).toFixed(2);
      giftText.innerText = "Add Just $" + giftRemaining + " more to get a free gift";
    }
  }
}

};


document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const emailInput = document.querySelector(
      'input.tangent_form_input_custom[type="email"]'
    );
    if (emailInput && !emailInput.placeholder) {
      emailInput.placeholder = "Email";
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});




//language switcher js for mobile
document.addEventListener('DOMContentLoaded', function () {
  const languageSwitcher = document.querySelector('.language-switcherct');

  if (!languageSwitcher) return;

  function updateLanguageSwitcher() {
    if (window.innerWidth <= 550) {
      const select = languageSwitcher.querySelector('select');

      if (!select) return;

      Array.from(select.options).forEach(function (option) {
        const flag = option.textContent.trim().split(' ')[0];
        option.textContent = flag;
      });
    }
  }

  updateLanguageSwitcher();

  window.addEventListener('resize', updateLanguageSwitcher);
});